// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1JVVx","dragIcon":"Choice_dragIcon__pTEWF","left":"Choice_left__TIN48","input":"Choice_input__3rYL0"};